/* Neon Interactions — LumiNéon v3
   Premium devis popup, logo upload, scroll utility
*/

let isDevisPopupOpen = false;

// =======================================================
// DEVIS POPUP — Premium v3
// =======================================================
function openDevisPopup() {
  const url = new URL('/pages/configurateur', location.origin);
  const preview = new URL(location.href).searchParams.get('preview_theme_id');
  if (preview && /^\d+$/.test(preview)) { url.searchParams.set('preview_theme_id', preview); url.searchParams.set('pb', '0'); }
  location.assign(url.href);
}

function closeDevisPopup() {
  var popup = document.getElementById('devis-popup');
  if (popup) { popup.remove(); document.body.style.overflow = ''; isDevisPopupOpen = false; }
}

// =======================================================
// LOGO UPLOAD
// =======================================================
function initializeLogoUpload() {
  var lbl = document.getElementById('upload-label');
  var inp = document.getElementById('logo-upload');
  if (!lbl || !inp) return;

  inp.addEventListener('change', function() { if (this.files[0]) processLogoFile(this.files[0]); });
  lbl.addEventListener('dragover', function(e) { e.preventDefault(); });
  lbl.addEventListener('dragenter', function(e) {
    e.preventDefault();
    lbl.style.borderColor = '#00dcff';
    lbl.style.color = '#00dcff';
    lbl.style.background = 'rgba(0,220,255,0.03)';
  });
  lbl.addEventListener('dragleave', function(e) {
    e.preventDefault();
    if (!e.currentTarget.contains(e.relatedTarget)) resetUploadStyle();
  });
  lbl.addEventListener('drop', function(e) {
    e.preventDefault();
    if (e.dataTransfer.files.length > 0) {
      var dt = new DataTransfer();
      dt.items.add(e.dataTransfer.files[0]);
      inp.files = dt.files;
      processLogoFile(e.dataTransfer.files[0]);
    }
  });
}

function processLogoFile(file) {
  if (file.size > 10 * 1024 * 1024) { alert('Fichier trop volumineux (max 10 Mo)'); return; }
  var ok = ['image/jpeg','image/png','image/gif','image/svg+xml','application/pdf'];
  if (!ok.includes(file.type)) { alert('Format non support\u00E9.'); return; }

  var el = function(id) { return document.getElementById(id); };
  if (el('file-name')) el('file-name').textContent = file.name;
  if (el('file-size')) el('file-size').textContent = formatFileSize(file.size);
  if (el('file-preview')) el('file-preview').style.display = 'block';
  if (el('upload-text')) el('upload-text').textContent = 'Changer le fichier';

  var lbl = el('upload-label');
  if (lbl) { lbl.style.borderColor = '#10b981'; lbl.style.color = '#10b981'; lbl.style.background = 'rgba(16,185,129,0.04)'; }
}

function removeLogoFile() {
  var inp = document.getElementById('logo-upload');
  if (inp) inp.value = '';
  var fp = document.getElementById('file-preview');
  if (fp) fp.style.display = 'none';
  var ut = document.getElementById('upload-text');
  if (ut) ut.textContent = 'Glissez ou cliquez pour ajouter un logo / image';
  resetUploadStyle();
}

function resetUploadStyle() {
  var lbl = document.getElementById('upload-label');
  if (lbl && !document.getElementById('logo-upload').files[0]) {
    lbl.style.borderColor = '';
    lbl.style.color = '';
    lbl.style.background = '';
  }
}

function formatFileSize(bytes) {
  if (!bytes) return '0 octets';
  var k = 1024, s = ['octets','Ko','Mo','Go'], i = Math.floor(Math.log(bytes) / Math.log(k));
  return parseFloat((bytes / Math.pow(k, i)).toFixed(1)) + ' ' + s[i];
}

// =======================================================
// UTILITY
// =======================================================
function scrollToSection(sectionId) {
  if (window.location.pathname === '/' || window.location.pathname === '') {
    var el = document.getElementById(sectionId);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  } else {
    window.location.href = '/#' + sectionId;
  }
}

window.openDevisPopup = openDevisPopup;
window.closeDevisPopup = closeDevisPopup;
window.scrollToSection = scrollToSection;
window.removeLogoFile = removeLogoFile;
